// extracted by mini-css-extract-plugin
export default {"button":"Button_button__2LuFs","secondary":"Button_secondary__piEa+"};